var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pane-content"},[_c('h3',{staticClass:"medium-blue"},[_vm._v(_vm._s(_vm.$t('review.subTitulo', { procedure: _vm.procedureId})))]),_c('ReviewLayout',{attrs:{"procedure-id":_vm.procedureId,"account-id":_vm.accountId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }